<template>
  <div>
    <h2 class="h5 ml-4 mt-4 mb-2">
      Missing Products
      <span class="badge ml-1" :class="missingItemCounts.products === 0 ? 'badge-secondary' : 'badge-warning'">{{
        missingItemCounts.products
      }}</span>
    </h2>
    <div class="list-group" v-if="missingItemCounts.products > 0">
      <router-link
        class="list-group-item alert-warning list-group-item-action"
        v-for="(amount, productId) in missingItems"
        :key="productId"
        :to="{ name: 'product', params: { productId } }"
      >
        {{ amount }}x {{ productTitle(productId) }}
        <span v-if="productTemporarilyUnavailable(productId)" class="badge ml-1 badge-warning">
          Zur Zeit nicht verfügbar
        </span>
      </router-link>
    </div>
    <div class="alert alert-secondary text-center pt-5 pb-5" v-else role="alert">
      <p>
        There are <span class="badge badge-success">{{ missingItemCounts.products }} products</span> missing 🎉
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    missingItems: {
      type: Object,
      required: true
    },
    missingItemCounts: {
      type: Object,
      required: true
    }
  },
  methods: {
    productTitle(productId) {
      const product = this.$store.state.products.find(p => p.id === productId)
      return `${product.brandName} ${product.label}`
    },
    productTemporarilyUnavailable(productId) {
      return this.$store.state.products.find(p => p.id === productId).temporarilyUnavailable
    }
  }
}
</script>
